import React from 'react';
import ReactLoading from 'react-loading';

const LoadingState = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '50%' }}>
        <ReactLoading type={'spin'} color={'white'} height={'75px'} width={'75px'} />
      </div>
    </div>
  );
};

export default LoadingState;
